var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/reactcss/~/lodash/_Symbol.js
// module id = 121
// module chunks = 0